// Реализация модального окна
import GraphModal from 'graph-modal';
const modal = new GraphModal();

// Подключение свайпера
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay]);
const swiper = new Swiper('.swiper-comments', {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 16,
  navigation: {
    nextEl: '.swiper-comments-button-next',
    prevEl: '.swiper-comments-button-prev',
  },
  pagination: {
    el: '.swiper-comments-pagination',
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 16
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16
    },
    grabCursor: true,
  },
});
const swiperReviewBullet = ["Все каналы связи в одном окне", "Интеграция с CRM", "Прогрессивно-предиктивный дозвон", "Полный контроль" ]
const swiperReview = new Swiper('.swiper-review', {
  slidesPerView: "1",
  spaceBetween: 16,
  navigation: {
    nextEl: '.swiper-review-button-next',
    prevEl: '.swiper-review-button-prev',
  },
  pagination: {
    el: '.swiper-review-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return `<span class="${className}">${swiperReviewBullet[index]}</span>`;
    }
  },
});

document.querySelectorAll('input[type="tel"]').forEach(function(input) {
  input.onkeydown = function(e) {
    inputphone(e, this);
  }
});

function inputphone(e, phone){
  function stop(evt) {
    evt.preventDefault();
  }
  let key = e.key, v = phone.value, not = key.replace(/([0-9])/, 1)

  if(not == 1 || 'Backspace' === not){
    if('Backspace' != not){
      if(v.length < 3 || v ===''){phone.value= '+7('}
      if(v.length === 6){phone.value= v +')'}
      if(v.length === 10){phone.value= v +'-'}
      if(v.length === 13){phone.value= v +'-'}
    }
  }else{stop(e)}  }



document.getElementById("calculateForm").addEventListener('submit',function (e){
  e.preventDefault();
  const data = {
    name: this.querySelector('input[name="name"]').value,
    phone: this.querySelector('input[name="phone"]').value,
    email: this.querySelector('input[name="email"]').value,
    organization: this.querySelector('input[name="organization"]').value,
    numberOperatorCompany: this.querySelector('input[name="number-operator-company"]').value,
    integration: this.querySelector('input[name="integration"]:checked').value,
    integrationName: this.querySelector('input[name="integration-name"]').value,
    omnichannel: this.querySelector('input[name="omnichannel"]:checked').value,
  };

  fetch('https://tehnotelecom.bpium.ru/api/webrequest/application', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response)
    .then(data => {
      return fetch('./mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    })
    .then(response => {
      if (response.ok) {
        console.log('Успешная отправка:');
        modal.close();
        modal.open('calculate-success');
      }
    })
    .catch(error => {
      console.error('Ошибка отправки:', error);
    });
});

document.getElementById("testingForm").addEventListener('submit',function (e){
  e.preventDefault();
  const data = {
    name: this.querySelector('input[name="name"]').value,
    phone: this.querySelector('input[name="phone"]').value,
    email: this.querySelector('input[name="email"]').value,
    organization: this.querySelector('input[name="organization"]').value,
    numberOperatorCompany: this.querySelector('input[name="number-operator-company"]').value,
    integration: this.querySelector('input[name="integration"]:checked').value,
    integrationName: this.querySelector('input[name="integration-name"]').value,
    omnichannel: this.querySelector('input[name="omnichannel"]:checked').value,
  }


  fetch('https://tehnotelecom.bpium.ru/api/webrequest/application', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response)
    .then(data => {
      return fetch('./mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    })
    .then(response => {
      if (response.ok) {
        console.log('Успешная отправка:');
        modal.close();
        modal.open('testing-success');
      }
    })
    .catch(error => {
      console.error('Ошибка отправки:', error);
    });
})

document.getElementById("industriesForm").addEventListener('submit',function (e){
  e.preventDefault();
  const data = {
    name: this.querySelector('input[name="name"]').value,
    phone: this.querySelector('input[name="phone"]').value,
    email: this.querySelector('input[name="email"]').value,
    organization: this.querySelector('input[name="organization"]').value,
    industries: this.querySelector('input[name="industries"]').value,
    numberOperatorCompany: this.querySelector('input[name="number-operator-company"]').value
  }

  fetch('https://tehnotelecom.bpium.ru/api/webrequest/application', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response)
    .then(data => {
      return fetch('./mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    })
    .then(response => {
      if (response.ok) {
        console.log('Успешная отправка:');
        modal.close();
        modal.open('industries-success');
      }
    })
    .catch(error => {
      console.error('Ошибка отправки:', error);
    });
})


document.getElementById("presentationForm").addEventListener('submit',function (e){
  e.preventDefault();
  const data = {
    name: this.querySelector('input[name="name"]').value,
    phone: this.querySelector('input[name="phone"]').value,
    email: this.querySelector('input[name="email"]').value,
    organization: this.querySelector('input[name="organization"]').value,
    numberOperatorCompany: this.querySelector('input[name="number-operator-company"]').value
  }

  fetch('https://tehnotelecom.bpium.ru/api/webrequest/application', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => response)
    .then(data => {
      return fetch('./mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
    })
    .then(response => {
      if (response.ok) {
        console.log('Успешная отправка:');
        modal.close();
        modal.open('presentation-success');
      }
    })
    .catch(error => {
      console.error('Ошибка отправки:', error);
    });
})
